/* eslint-disable react/no-array-index-key */
import React from 'react';
import isEmpty from 'lodash/isEmpty';
import isObject from 'lodash/isObject';
import { Helmet } from 'react-helmet';
// import { defineMessages, injectIntl } from 'react-intl';

import * as AppPropTypes from '../../lib/PropTypes';

// const messages = defineMessages({
//     title: {
//         id: 'meta.title',
//         defaultMessage: 'NTE',
//     },
// });

const propTypes = {
    // intl: AppPropTypes.intl.isRequired,
    page: AppPropTypes.page,
};

const defaultProps = {
    page: {
        share: {},
    },
};

const PageMeta = ({ page }) => {
    const { share } = page;
    if (!share) return null;
    const { title, description, image, url } = share;
    if (!title) return null;

    return (
        <Helmet>
            <title>{title}</title>
            {!isEmpty(description) ? <meta name="description" content={description} /> : null}
            <meta property="og:title" content={title} />
            {!isEmpty(image) && !isObject(image) ? (
                <meta property="og:image" content={image} />
            ) : null}
            {!isEmpty(image) ? <meta property="og:image" content={image} /> : null}
            <meta property="og:type" content="website" />
            {!isEmpty(description) ? (
                <meta property="og:description" content={description} />
            ) : null}
            <meta property="og:url" content={url} />
        </Helmet>
    );
};

PageMeta.propTypes = propTypes;
PageMeta.defaultProps = defaultProps;

export default PageMeta;
